module.exports = __webpack_public_path__ + "static/media/whatsapp.d5900a1c.svg";